import { call, put } from 'redux-saga/effects';
import i18next from 'i18next';

import { apiCallWithApiKey } from '../services/api';
import {
  openAddReimbursementMethodModal,
  sendVerificationCodeFailed,
  sendVerificationCodeSuccess,
  verifyCodeAttempt,
  verifyCodeFailed,
  verifyCodeSuccess,
} from '../actions';
import { REIMBURSEMENT_METHODS } from '../constants';
import { OTP_VERIFICATION_TYPE } from '../components/common/otp/otp.constants';
import { useReimbursementMethodDisclaimerForSagas } from '../services/featureFlagsForSagas';

export function* sendVerificationCode(dispatch, { payload }) {
  const errorGeneric = i18next.t('common:anErrorHasOccurred');

  try {
    const {
      email,
      phoneNumber,
      serviceName,
      verificationType,
    } = payload;
    const useGenericError = false;

    const options = {
      body: {
        Channel: verificationType,
        ServiceName: serviceName,
      },
      method: 'POST',
    };

    if (verificationType === OTP_VERIFICATION_TYPE.SMS) {
      const phoneNumberClean = phoneNumber.replace(/\D+/g, '');
      options.body.PhoneNumber = phoneNumberClean;
      options.body.MessagingServiceSid =
        process.env.REACT_APP_TWILIO_MESSAGING_SERVICE_SID;
    } else {
      options.body.Email = email;
    }

    const response = yield call(
      apiCallWithApiKey,
      'messaging/SendVerification',
      options,
      dispatch,
      useGenericError,
    );

    if (response?.success) {
      yield put(sendVerificationCodeSuccess());
    } else {
      const errorMessage = response?.message || errorGeneric;
      yield put(sendVerificationCodeFailed(errorMessage));
    }
  } catch (_) {
    yield put(sendVerificationCodeFailed(errorGeneric));
  }
}

export function* verifyCode(dispatch, { payload }) {
  try {
    const { code, email, phoneNumber, verificationType } = payload;

    yield put(verifyCodeAttempt());

    const options = {
      body: {
        Channel: verificationType,
        Code: code,
      },
      method: 'POST',
    };

    if (verificationType === OTP_VERIFICATION_TYPE.SMS) {
      options.body.PhoneNumber = phoneNumber;
    } else {
      options.body.Email = email;
    }

    const response = yield call(
      apiCallWithApiKey,
      'messaging/VerifyCode',
      options,
      dispatch,
    );

    if (response.success && response.status < 400) {
      yield put(verifyCodeSuccess(response?.verificationToken));

      const newDesign = yield useReimbursementMethodDisclaimerForSagas();
      const defaultReimbursementMethod = newDesign
        ? REIMBURSEMENT_METHODS.deposit : REIMBURSEMENT_METHODS.check;

      yield put(openAddReimbursementMethodModal(defaultReimbursementMethod));
    } else {
      const errorMessage = response?.message;
      yield put(verifyCodeFailed(errorMessage));
    }
  } catch (error) {
    yield put(verifyCodeFailed(error?.message));
  }
}
